import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { ValidationErrors } from '@angular/forms';
import { fromEvent, Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-input-text',
  templateUrl: './input-text.component.html',
  styleUrls: ['./input-text.component.scss']
})
export class InputTextComponent {
  @Input() label?: string;
  @Input() isRequired = false;
  @Input() isDirty = false;
  @Input() value: string = '';
  @Input() errors?: ValidationErrors | null;

  get errorOutput(): string[] {
    const res: string[] = [];
    if (!this.errors) return res;

    for (const k in this.errors) {
      if (Object.prototype.hasOwnProperty.call(this.errors, k)) {
        const element = this.errors[k];
        if(!!element)res.push(k === 'message' ? element : k);
      }
    }

    return res;
  }
}
